var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0233 3.39502C10.1616 3.39502 7.02331 6.53335 7.02331 10.395V13.7667C7.02331 14.4784 6.71998 15.5634 6.35831 16.17L5.01665 18.3984C4.18831 19.775 4.75998 21.3034 6.27665 21.8167C11.305 23.4967 16.73 23.4967 21.7583 21.8167C23.17 21.35 23.7883 19.6817 23.0183 18.3984L21.6766 16.17C21.3266 15.5634 21.0233 14.4784 21.0233 13.7667V10.395C21.0233 6.54502 17.8733 3.39502 14.0233 3.39502Z",
    stroke: "#2C3941",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1817 3.73318C15.82 3.62818 15.4467 3.54652 15.0617 3.49985C13.9417 3.35985 12.8683 3.44152 11.865 3.73318C12.2033 2.86985 13.0433 2.26318 14.0233 2.26318C15.0033 2.26318 15.8433 2.86985 16.1817 3.73318Z",
    stroke: "#2C3941",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5233 22.2368C17.5233 24.1618 15.9483 25.7368 14.0233 25.7368C13.0666 25.7368 12.18 25.3402 11.55 24.7102C10.92 24.0802 10.5233 23.1935 10.5233 22.2368",
    stroke: "#2C3941",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.85039aba1d644187d95e1804c24f8c14.svg";
export { ForwardRef as ReactComponent };